export default "__VITE_ASSET__780dea0d__"